import { render, staticRenderFns } from "./SUPACellPods.vue?vue&type=template&id=24eb1d52&scoped=true&"
import script from "./SUPACellPods.vue?vue&type=script&lang=ts&"
export * from "./SUPACellPods.vue?vue&type=script&lang=ts&"
import style0 from "./SUPACellPods.vue?vue&type=style&index=0&id=24eb1d52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24eb1d52",
  null
  
)

export default component.exports